import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.grid}>
          {/* Brand */}
          <div style={styles.brand}>
            <div style={styles.logoRow}>
              <div style={styles.logoIcon}>TG</div>
              <span style={styles.logoText}>Tura<span style={styles.logoAccent}>Grammar</span></span>
            </div>
            <p style={styles.tagline}>AI-powered writing assistant for professionals. Fix grammar, check plagiarism, and improve your writing instantly.</p>
            <p style={styles.company}>By <strong>Turacoz Healthcare Solutions</strong></p>
          </div>

          {/* Product */}
          <div style={styles.col}>
            <h4 style={styles.colTitle}>Product</h4>
            <Link to="/editor" style={styles.link}>Grammar Checker</Link>
            <Link to="/editor" style={styles.link}>Spell Checker</Link>
            <Link to="/editor" style={styles.link}>AI Writing Assistant</Link>
            <Link to="/help" style={styles.link}>Help Manual</Link>
          </div>

          {/* Company */}
          <div style={styles.col}>
            <h4 style={styles.colTitle}>Company</h4>
            <Link to="/pricing" style={styles.link}>Pricing</Link>
            <Link to="/about" style={styles.link}>About Us</Link>
            <Link to="/contact" style={styles.link}>Contact</Link>
          </div>

          {/* Legal */}
          <div style={styles.col}>
            <h4 style={styles.colTitle}>Legal</h4>
            <Link to="/privacy" style={styles.link}>Privacy Policy</Link>
            <Link to="/terms" style={styles.link}>Terms of Service</Link>
          </div>
        </div>

        <div style={styles.bottom}>
          <p style={styles.copyright}>© {new Date().getFullYear()} Turacoz Healthcare Solutions. All rights reserved.</p>
          <p style={styles.powered}>Developed by Liyakhath.shaik</p>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footer: { background: '#111827', color: '#9ca3af', padding: '60px 0 30px' },
  container: { maxWidth: '1200px', margin: '0 auto', padding: '0 24px' },
  grid: { display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: '40px', marginBottom: '48px' },
  brand: {},
  logoRow: { display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' },
  logoIcon: { width: '36px', height: '36px', borderRadius: '8px', background: 'linear-gradient(135deg, #4f46e5, #7c3aed)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700', fontSize: '14px' },
  logoText: { fontSize: '20px', fontWeight: '700', color: '#f9fafb' },
  logoAccent: { color: '#818cf8' },
  tagline: { fontSize: '14px', lineHeight: '1.7', color: '#6b7280', marginBottom: '12px' },
  company: { fontSize: '13px', color: '#6b7280' },
  col: { display: 'flex', flexDirection: 'column', gap: '10px' },
  colTitle: { fontSize: '14px', fontWeight: '600', color: '#f9fafb', marginBottom: '8px' },
  link: { textDecoration: 'none', color: '#6b7280', fontSize: '14px', transition: 'color 0.2s' },
  bottom: { borderTop: '1px solid #1f2937', paddingTop: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  copyright: { fontSize: '13px', color: '#4b5563' },
  powered: { fontSize: '13px', color: '#4b5563' },
};

export default Footer;
